<section id="dashboard-calendar-chartjs-bar-stats" class="h-100">
    <div class="card h-100 m-0 pr-0 pl-0">
        <div class="card-content h-100">
            <div class="card-body h-100 pr-0 pb-0 pt-2" [ngClass]="{
            'd-flex align-items-center justify-content-center': isEmpty
        }">
                <div id="chart" class="chart h-100" [ngClass]="{
            'd-flex align-items-center justify-content-center': isEmpty
        }">
                    <canvas *ngIf="!isEmpty; else noResults" class="chart" baseChart [datasets]="data" [labels]="labels"
                        [options]="options"></canvas>

                    <ng-template #noResults>
                        <div class="no-results">
                            <span>No se encontraron eventos que coincidan con los filtros.</span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>

        <app-load-screen *ngIf="isLoading" loadingText="Cargando estadísticas del calendario..."></app-load-screen>
    </div>
</section>